import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure1 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '1000px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#ed7d31', '#5b9bd5'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
      borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [
	   'Malawi 2015',
	   'Nigéria 2018',
	   'Burundi 2016',
	   'Ouganda 2014',
	   'Togo 2018',
	   'Pakistan 2018',
	   'Cameroun 2018',
	   'Zambie 2018',
	   'Niger 2018',
	   'Afrique du Sud 2016',
	   'Guinée 2018',
	   'Bénin 2018',
	   'Côte d’Ivoire 2018',
	   'Zimbabwe 2015',
	   'Guinée-Bissau 2018',
	   'Burkina Faso 2018',
	   'République-Unie de Tanzanie 2013',
	   'Mali 2018',
	   'Éthiopie 2016',
	   'Albanie 2018',
	   'Sénégal 2018',
	   'Arménie 2016',
	   'Indonésie 2017',
	   'Mozambique 2011',
	   'Lesotho 2013',
	   'Mongolie 2012',
	   'Rwanda 2015',
	   'Belgique 2011',
	   'Nouvelle-Zélande 2013',
	   'Suède 2011',
	   'Pays-Bas 2011',
	   'République de Corée 2016',
	   'Costa Rica 2011',
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
		      format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 100,
      min: 0,
      tickInterval: 25,
      gridLineWidth: 0,
      title: {
        text: null,
	style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
    name: 'Population totale',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
	     1.90,
	     7.70,
	     7.80,
	     8.00,
	     9.20,
	     9.80,
	     9.80,
	     10.30,
	     12.80,
	     15.80,
	     16.50,
	     17.10,
	     17.90,
	     21.40,
	     21.70,
	     24.60,
	     25.00,
	     26.90,
	     32.20,
	     36.40,
	     39.90,
	     41.90,
	     45.80,
	     49.80,
	     61.10,
	     65.40,
	     85.80,
	     94.80,
	     99.00,
	     99.30,
	     100.00,
	     100.00,
	     100.00,

      ]
    },{
        name: 'Femmes',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
	     22.60,
	     3.40,
	     3.60,
	     52.50,
	     29.20,
	     1.50,
	     2.70,
	     3.90,
	     1.80,
	     10.60,
	     6.60,
	     10.00,
	     9.00,
	     8.20,
	     21.20,
	     13.20,
	     33.90,
	     11.40,
	     18.00,
	     21.90,
	     22.40,
	     29.70,
	     12.00,
	     11.20,
	     null,
	     26.80,
	     86.40,
	     54.30,
	     null,
	     30.20,
	     64.00,
	     null,
	     null,
      ],
    }]
}
